@if (preview(); as current) {
  <div class="attachment-preview-backdrop" (click)="close()">
    <section
      #dialog
      class="attachment-preview-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ticket-attachment-preview-title"
      tabindex="-1"
      (click)="$event.stopPropagation()"
    >
      <header class="attachment-preview-header">
        <strong id="ticket-attachment-preview-title" [title]="current.name">
          {{ current.name }}
        </strong>
        <span class="attachment-preview-actions">
          <a
            [href]="current.originalUrl"
            [download]="current.name"
            [attr.aria-label]="downloadLabel() + ': ' + current.name"
          >{{ downloadLabel() }}</a>
          <button
            type="button"
            [attr.aria-label]="closeLabel()"
            [title]="closeLabel()"
            (click)="close()"
          >
            <ng-icon name="xmark" size="21" />
          </button>
        </span>
      </header>
      <div class="attachment-preview-body">
        @if (loading()) {
          <div class="attachment-preview-loading">{{ loadingLabel() }}</div>
        } @else if (current.kind === 'image' && current.imageUrl) {
          <img [src]="current.imageUrl" [alt]="current.name" />
        } @else if (current.kind === 'pdf' && current.pdfUrl) {
          <iframe [src]="current.pdfUrl" [title]="current.name"></iframe>
        } @else if (current.kind === 'spreadsheet' && current.spreadsheet) {
          <div class="spreadsheet-preview">
            @if (current.spreadsheet.sheets.length > 1) {
              <div class="spreadsheet-sheets" role="tablist" [attr.aria-label]="sheetLabel()">
                @for (sheet of current.spreadsheet.sheets; track sheet.name; let index = $index) {
                  <button
                    type="button"
                    role="tab"
                    [attr.aria-selected]="selectedSheetIndex() === index"
                    [class.active]="selectedSheetIndex() === index"
                    (click)="selectSheet(index)"
                  >{{ sheet.name }}</button>
                }
              </div>
            }
            @if (selectedSheet(); as sheet) {
              @if (sheet.truncated) {
                <div class="spreadsheet-notice">{{ truncatedLabel() }}</div>
              }
              @if (sheet.rows.length) {
                <div class="spreadsheet-grid">
                  <table>
                    <thead>
                      <tr>
                        <th class="row-coordinate" scope="col"></th>
                        @for (column of sheet.columns; track column) {
                          <th scope="col">{{ column }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of sheet.rows; track $index; let rowIndex = $index) {
                        <tr>
                          <th class="row-coordinate" scope="row">{{ sheet.startRow + rowIndex }}</th>
                          @for (cell of row; track $index) {
                            <td [title]="cell">{{ cell }}</td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                <div class="spreadsheet-empty">{{ emptySheetLabel() }}</div>
              }
            } @else {
              <div class="spreadsheet-empty">{{ emptySheetLabel() }}</div>
            }
          </div>
        }
      </div>
    </section>
  </div>
}
